import React, { useContext } from 'react';
import styled from 'styled-components'
import { MenuContext } from '../layout/Body';
import { SCREEN_MAX_WIDTH } from '../../constants/config';

const Burger = styled.div`
    height: 40px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1;
    border-radius: 15%;
    position: relative;
    overflow: hidden;
    cursor: pointer;
`;
const Span = styled.span`
    display: block;
    width: 90%;
    height: 8%;
    border-radius: 100vh;
    background: ${({ theme }) => theme.white};
    position: absolute;
    transition: 0.5s;

    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        background: ${({ open, theme }) => open ? theme.white : theme.text};
        z-index: 10;
    }

    ${({ open }) => open ? `
        &:nth-child(2) {
            bottom: 50%;
            transform: translateY(50%) rotate(-225deg);
            transition-delay: 0.25s;
        }
        &:nth-child(1) {
            top: 50%;
            transform: translateY(-50%) rotate(225deg);
            transition-delay: 0.25s;
        }
        &:nth-child(3) {
            transform: translateX(150%);
        }`
        :
        `
        &:nth-child(2) {
            bottom: 25%;
        }
        &:nth-child(1) {
            top: 25%;
        }
        `
    }
`;

const BurgerMenu = ({ ...props }) => {
    const { isOpen, setIsOpen } = useContext(MenuContext);

    return (
        <Burger
            isOpen={isOpen}
            onClick={(e) => {
                setIsOpen(!isOpen)
            }}
            {...props}
        >
            <Span open={isOpen}></Span>
            <Span open={isOpen}></Span>
            <Span open={isOpen}></Span>
        </Burger>
    );
}

export default BurgerMenu;